
const WhyFGAPrestigeSection = () => {
  return (
    <section
      style={{ backgroundColor: '#F7F8FA' }}
    >
      <div
        style={{
          backgroundColor: '#F7F8FA'
        }}
      >
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '0',
            width: '100%',
            margin: '0'
          }}
        >
          {/* Content Column - First */}
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              padding: '80px'
            }}
          >
            <div style={{ width: '100%' }}>
              <h2
                style={{
                  fontFamily: 'Cardo, serif',
                  fontSize: '40px',
                  color: '#111',
                  fontWeight: '400',
                  marginBottom: '32px',
                  lineHeight: '1.2'
                }}
              >
                Why FGA Prestige
              </h2>
              <div
                style={{
                  fontFamily: 'Plus Jakarta Sans, sans-serif',
                  fontSize: '16px',
                  lineHeight: '1.6',
                  color: '#7B7B7B'
                }}
              >
                <div style={{ marginBottom: '24px' }}>
                  <h3 style={{ 
                    fontFamily: 'Plus Jakarta Sans, sans-serif',
                    fontSize: '16px',
                    fontWeight: '600',
                    color: '#764F2B',
                    marginBottom: '12px'
                  }}>
                    Bespoke Relationships
                  </h3>
                  <p style={{ marginBottom: '16px' }}>
                    Our insiders provide privileged access to global flagship brands and hidden luxury gems alike.
                  </p>
                </div>

                <div style={{ marginBottom: '24px' }}>
                  <h3 style={{ 
                    fontFamily: 'Plus Jakarta Sans, sans-serif',
                    fontSize: '16px',
                    fontWeight: '600',
                    color: '#764F2B',
                    marginBottom: '12px'
                  }}>
                    Discreet Service
                  </h3>
                  <p style={{ marginBottom: '16px' }}>
                    Every request is handled with the utmost privacy and professionalism, respecting your time and lifestyle.
                  </p>
                </div>

                <div>
                  <h3 style={{ 
                    fontFamily: 'Plus Jakarta Sans, sans-serif',
                    fontSize: '16px',
                    fontWeight: '600',
                    color: '#764F2B',
                    marginBottom: '12px'
                  }}>
                    Global Expertise
                  </h3>
                  <p>
                    With reach across the world's capitals of luxury, our team makes the extraordinary routine.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Image Column - Second */}
          <div
            style={{
              display: 'flex',
              alignItems: 'stretch',
              width: '100%',
              height: '100%'
            }}
          >
            <img
              src="/Bespoke Shopping/Why FGA Prestige.png"
              alt="Why FGA Prestige - Luxury landscape view"
              style={{
                width: '100%',
                height: '100%',
                minHeight: '560px',
                objectFit: 'cover',
                borderRadius: '0',
                display: 'block'
              }}
            />
          </div>
        </div>
      </div>

      <style jsx>{`
        @media (max-width: 1199px) {
          div[style*="grid-template-columns"] {
            grid-template-columns: 1fr !important;
            gap: 0 !important;
          }
          
          div[style*="padding: 80px"] {
            order: 2;
            padding: 40px !important;
          }
          
          div[style*="align-items: center"] {
            order: 1;
          }
        }

        @media (max-width: 899px) {
          section img {
            min-height: 300px !important;
          }
        }

        @media (min-width: 1200px) {
          div[style*="grid-template-columns"] {
            grid-template-columns: 1fr 1fr !important;
          }
        }
      `}</style>
    </section>
  )
}

export default WhyFGAPrestigeSection